import React from 'react';
import styles from './SelectionMenu.module.scss';

interface NavMenuProps {
    items: { label: string; onClick: () => void }[];
}

const SelectionMenu: React.FC<NavMenuProps> = ({ items }) => {
    return (
        <nav className={styles.navContainer}>
            <ul className={styles.menuList}>
                {items.map((item) => (
                    <li
                        key={item.label}
                        className={styles.menuItem}
                        onClick={item.onClick}
                    >
                        {item.label}
                    </li>
                ))}
            </ul>
        </nav>
    );
};

export default SelectionMenu;
